export default "/images/faf581809f281388cda91acaa9979f9b.avif";